export default (sitemap: SitemapBuilder) =>
{
    sitemap.before('[[[Repozytorium plików]]]', [
        {
            name: '[[[AI CORE]]]',
            short: '[[[AI CORE]]]',
            icon: 'fal fa-fw fa-microchip-ai',
            namespace: 'Ideo.Core.Common.Application.Permissions.AiCore',
            visible: false,
            children: [
                {
                    name: '[[[Generator dynamicznych formularzy]]]',
                    icon: 'far fa-fw fa-search',
                    route: 'aicore-dynamic-forms-generator',
                    auth: { all: ['DynamicFormsGeneratorPermissions@Access'], any: [] },
                    visible: false
                },
                {
                    name: '[[[Edytor tekstu]]]',
                    icon: 'far fa-fw fa-search',
                    route: 'aicore-text-editor',
                    auth: { all: ['TextEditorPermissions@Access'], any: [] },
                    visible: false
                },
                {
                    name: '[[[Generator metadanych obrazu]]]',
                    icon: 'far fa-fw fa-search',
                    route: 'aicore-image-metadata',
                    auth: { all: ['ImageMetadataGeneratorPermissions@Access'], any: [] },
                    visible: false
                },
                {
                    name: '[[[Generator obrazów]]]',
                    icon: 'far fa-fw fa-image',
                    route: 'aicore-image-generator',
                    auth: { all: ['ImageGeneratorPermissions@Access'], any: [] },
                    visible: false
                }
            ]
        }
    ]);
};
